/* tslint:disable */
/* eslint-disable */
/**
 * WebCore
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { MigrationImportResult } from '../Models';
// @ts-ignore
import type { MigrationObject } from '../Models';
// @ts-ignore
import type { MigrationSearchResult } from '../Models';
// @ts-ignore
import type { MigrationSummary } from '../Models';
/**
 * MigrationsApi - axios parameter creator
 */
export const MigrationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {boolean} [isSupported] 
         * @param {boolean} [isBroken] 
         * @param {boolean} [isRedirected] 
         * @param {boolean} [isSkipped] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsGet: async (search?: string, isSupported?: boolean, isBroken?: boolean, isRedirected?: boolean, isSkipped?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/migrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (isSupported !== undefined) {
                localVarQueryParameter['isSupported'] = isSupported;
            }

            if (isBroken !== undefined) {
                localVarQueryParameter['isBroken'] = isBroken;
            }

            if (isRedirected !== undefined) {
                localVarQueryParameter['isRedirected'] = isRedirected;
            }

            if (isSkipped !== undefined) {
                localVarQueryParameter['isSkipped'] = isSkipped;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMigrationsIdDelete', 'id', id)
            const localVarPath = `/api/migrations/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMigrationsIdGet', 'id', id)
            const localVarPath = `/api/migrations/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {MigrationObject} [migrationObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsIdPut: async (id: string, migrationObject?: MigrationObject, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMigrationsIdPut', 'id', id)
            const localVarPath = `/api/migrations/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(migrationObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsIdSkipPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMigrationsIdSkipPost', 'id', id)
            const localVarPath = `/api/migrations/{id}/skip`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsIdUnskipPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMigrationsIdUnskipPost', 'id', id)
            const localVarPath = `/api/migrations/{id}/unskip`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {{ [key: string]: MigrationObject; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsImportPost: async (requestBody?: { [key: string]: MigrationObject; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/migrations/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MigrationObject} [migrationObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsPost: async (migrationObject?: MigrationObject, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/migrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(migrationObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {boolean} [isSupported] 
         * @param {boolean} [isBroken] 
         * @param {boolean} [isRedirected] 
         * @param {boolean} [isSkipped] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsSearchGet: async (search?: string, isSupported?: boolean, isBroken?: boolean, isRedirected?: boolean, isSkipped?: boolean, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/migrations/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (isSupported !== undefined) {
                localVarQueryParameter['isSupported'] = isSupported;
            }

            if (isBroken !== undefined) {
                localVarQueryParameter['isBroken'] = isBroken;
            }

            if (isRedirected !== undefined) {
                localVarQueryParameter['isRedirected'] = isRedirected;
            }

            if (isSkipped !== undefined) {
                localVarQueryParameter['isSkipped'] = isSkipped;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsSummaryGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/migrations/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MigrationsApi - functional programming interface
 */
export const MigrationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MigrationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {boolean} [isSupported] 
         * @param {boolean} [isBroken] 
         * @param {boolean} [isRedirected] 
         * @param {boolean} [isSkipped] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMigrationsGet(search?: string, isSupported?: boolean, isBroken?: boolean, isRedirected?: boolean, isSkipped?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MigrationObject>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMigrationsGet(search, isSupported, isBroken, isRedirected, isSkipped, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MigrationsApi.apiMigrationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMigrationsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMigrationsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MigrationsApi.apiMigrationsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMigrationsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MigrationObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMigrationsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MigrationsApi.apiMigrationsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {MigrationObject} [migrationObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMigrationsIdPut(id: string, migrationObject?: MigrationObject, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMigrationsIdPut(id, migrationObject, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MigrationsApi.apiMigrationsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMigrationsIdSkipPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMigrationsIdSkipPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MigrationsApi.apiMigrationsIdSkipPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMigrationsIdUnskipPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMigrationsIdUnskipPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MigrationsApi.apiMigrationsIdUnskipPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {{ [key: string]: MigrationObject; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMigrationsImportPost(requestBody?: { [key: string]: MigrationObject; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MigrationImportResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMigrationsImportPost(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MigrationsApi.apiMigrationsImportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MigrationObject} [migrationObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMigrationsPost(migrationObject?: MigrationObject, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MigrationObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMigrationsPost(migrationObject, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MigrationsApi.apiMigrationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {boolean} [isSupported] 
         * @param {boolean} [isBroken] 
         * @param {boolean} [isRedirected] 
         * @param {boolean} [isSkipped] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMigrationsSearchGet(search?: string, isSupported?: boolean, isBroken?: boolean, isRedirected?: boolean, isSkipped?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MigrationSearchResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMigrationsSearchGet(search, isSupported, isBroken, isRedirected, isSkipped, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MigrationsApi.apiMigrationsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMigrationsSummaryGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MigrationSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMigrationsSummaryGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MigrationsApi.apiMigrationsSummaryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MigrationsApi - factory interface
 */
export const MigrationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MigrationsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {boolean} [isSupported] 
         * @param {boolean} [isBroken] 
         * @param {boolean} [isRedirected] 
         * @param {boolean} [isSkipped] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsGet(search?: string, isSupported?: boolean, isBroken?: boolean, isRedirected?: boolean, isSkipped?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<MigrationObject>> {
            return localVarFp.apiMigrationsGet(search, isSupported, isBroken, isRedirected, isSkipped, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiMigrationsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<MigrationObject> {
            return localVarFp.apiMigrationsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {MigrationObject} [migrationObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsIdPut(id: string, migrationObject?: MigrationObject, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiMigrationsIdPut(id, migrationObject, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsIdSkipPost(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiMigrationsIdSkipPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsIdUnskipPost(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiMigrationsIdUnskipPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {{ [key: string]: MigrationObject; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsImportPost(requestBody?: { [key: string]: MigrationObject; }, options?: RawAxiosRequestConfig): AxiosPromise<MigrationImportResult> {
            return localVarFp.apiMigrationsImportPost(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MigrationObject} [migrationObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsPost(migrationObject?: MigrationObject, options?: RawAxiosRequestConfig): AxiosPromise<MigrationObject> {
            return localVarFp.apiMigrationsPost(migrationObject, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {boolean} [isSupported] 
         * @param {boolean} [isBroken] 
         * @param {boolean} [isRedirected] 
         * @param {boolean} [isSkipped] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsSearchGet(search?: string, isSupported?: boolean, isBroken?: boolean, isRedirected?: boolean, isSkipped?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<MigrationSearchResult> {
            return localVarFp.apiMigrationsSearchGet(search, isSupported, isBroken, isRedirected, isSkipped, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationsSummaryGet(options?: RawAxiosRequestConfig): AxiosPromise<MigrationSummary> {
            return localVarFp.apiMigrationsSummaryGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MigrationsApi - object-oriented interface
 */
export class MigrationsApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {boolean} [isSupported] 
     * @param {boolean} [isBroken] 
     * @param {boolean} [isRedirected] 
     * @param {boolean} [isSkipped] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMigrationsGet(search?: string, isSupported?: boolean, isBroken?: boolean, isRedirected?: boolean, isSkipped?: boolean, options?: RawAxiosRequestConfig) {
        return MigrationsApiFp(this.configuration).apiMigrationsGet(search, isSupported, isBroken, isRedirected, isSkipped, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMigrationsIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return MigrationsApiFp(this.configuration).apiMigrationsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMigrationsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return MigrationsApiFp(this.configuration).apiMigrationsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {MigrationObject} [migrationObject] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMigrationsIdPut(id: string, migrationObject?: MigrationObject, options?: RawAxiosRequestConfig) {
        return MigrationsApiFp(this.configuration).apiMigrationsIdPut(id, migrationObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMigrationsIdSkipPost(id: string, options?: RawAxiosRequestConfig) {
        return MigrationsApiFp(this.configuration).apiMigrationsIdSkipPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMigrationsIdUnskipPost(id: string, options?: RawAxiosRequestConfig) {
        return MigrationsApiFp(this.configuration).apiMigrationsIdUnskipPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {{ [key: string]: MigrationObject; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMigrationsImportPost(requestBody?: { [key: string]: MigrationObject; }, options?: RawAxiosRequestConfig) {
        return MigrationsApiFp(this.configuration).apiMigrationsImportPost(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MigrationObject} [migrationObject] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMigrationsPost(migrationObject?: MigrationObject, options?: RawAxiosRequestConfig) {
        return MigrationsApiFp(this.configuration).apiMigrationsPost(migrationObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {boolean} [isSupported] 
     * @param {boolean} [isBroken] 
     * @param {boolean} [isRedirected] 
     * @param {boolean} [isSkipped] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMigrationsSearchGet(search?: string, isSupported?: boolean, isBroken?: boolean, isRedirected?: boolean, isSkipped?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return MigrationsApiFp(this.configuration).apiMigrationsSearchGet(search, isSupported, isBroken, isRedirected, isSkipped, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMigrationsSummaryGet(options?: RawAxiosRequestConfig) {
        return MigrationsApiFp(this.configuration).apiMigrationsSummaryGet(options).then((request) => request(this.axios, this.basePath));
    }
}

